var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    class: ['container', 'select', 'focusable', ("s-" + (_vm.index))],
    attrs: {
      "for": ("checkbox-sentence-" + (_vm.index)),
      "tabindex": "0"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleOnKeyboardEnter($event);
      }
    }
  }, [_c('input', {
    attrs: {
      "id": ("checkbox-sentence-" + (_vm.index)),
      "name": "checkbox-sentence",
      "type": "radio",
      "tabindex": "-1"
    }
  }), _c('span', {
    class: _vm.getValidationClass(_vm.isChecked, _vm.hasError)
  }), _c('div', {
    staticClass: "step",
    attrs: {
      "aria-live": _vm.isChecked && !_vm.hasError ? 'polite' : 'off',
      "role": "region"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }